import { Injectable } from "@angular/core";
import { NetworkService } from "../../../shared/network.service";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  constructor(private networkservice: NetworkService) { }

  getUsersListApi(query: any) {
    return this.networkservice.get(
      "api/users/userList?" + query,
      null,
      null,
      "bearer"
    );
  }
  getRevenueListApi(query: any) {
    return this.networkservice.get(
      "api/booking/invoice?" + query,
      null,
      null,
      "bearer"
    );
  }

  getSettingsListApi(query: any) {
    return this.networkservice.get(
      "api/users/userList?role=manager&" + query,
      null,
      null,
      "bearer"
    );
  }

  getAllSettingsListApi(query: any) {
    return this.networkservice.get(
      "api/users/userList?role=manager&limit=1000&" + query,
      null,
      null,
      "bearer"
    );
  }
  postSettingsApi(body: any) {
    return this.networkservice.post("api/users?", body, null, "bearer");
  }

  putSettingsApi(body: any) {
    return this.networkservice.put("api/users?", body, null, "bearer");
  }
  verifyEmail(body: any) {
    return this.networkservice.post("api/users/verify", body, null, "bearer");
  }

  uploadImage(image: any) {
    const formData = new FormData();

    formData.append("image", image, "image.jpg");
    return this.networkservice.uploadImages(
      "api/s3upload/image-upload",
      formData,
      null,
      "bearer"
    );
  }
  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("image", image);
    return this.networkservice.uploadImages(
      "api/s3upload/image-upload",
      formData,
      null,
      "bearer"
    );
  }

  deleteUser(userId) {
    return this.networkservice.delete(
      "api/users/delete/" + userId,
      null,
      null,
      "bearer"
    );
  }

  adminDashboard() {
    return this.networkservice.get("api/dashboard", null, null, "bearer");
  }

  getTracks() {
    return this.networkservice.get("api/assessmentTrack", null, null, "bearer");
  }

  resetPassword(body: any) {
    return this.networkservice.post(
      "api/users/resetPassword",
      body,
      null,
      "bearer"
    );
  }

  //  new
  getVehicleListApi(query: any) {
    return this.networkservice.get(
      "api/vehicle/?" + query,
      null,
      null,
      "bearer"
    );
  }
  postVehicleApi(body: any) {
    return this.networkservice.post("api/vehicle?", body, null, "bearer");
  }
  deleteVehicle(vehicleId) {
    return this.networkservice.delete(
      "api/vehicle/" + vehicleId,
      null,
      null,
      "bearer"
    );
  }
  putVehicleApi(body: any) {
    return this.networkservice.put("api/vehicle?", body, null, "bearer");
  }
  putUserApi(body: any) {
    return this.networkservice.put("api/users?", body, null, "bearer");
  }
  getDriverListApi(query: any) {
    return this.networkservice.get(
      "api/driver/driverList?" + query,
      null,
      null,
      "bearer"
    );
  }
  getDriverLocationListApi() {
    return this.networkservice.get(
      "api/driver/driverList/currentLocation",
      null,
      null,
      "bearer"
    );
  }
  getDriverFeedbackApi(query: any) {
    return this.networkservice.get(
      "api/rating/details/driver?" + query,
      null,
      null,
      "bearer"
    );
  }
  getUserFeedbackApi(query: any) {
    return this.networkservice.get(
      "api/rating/details/user?" + query,
      null,
      null,
      "bearer"
    );
  }
  deleteDriver(userId) {
    return this.networkservice.delete(
      "api/driver/delete/" + userId,
      null,
      null,
      "bearer"
    );
  }
  getBookingListApi(query: any) {
    return this.networkservice.get(
      "api/booking?" + query,
      null,
      null,
      "bearer"
    );
  }
  putBookingApi(body: any) {
    return this.networkservice.put("api/booking?", body, null, "bearer");
  }
  cancelBooking(body: any) {
    return this.networkservice.post(
      "api/booking/cancel?",
      body,
      null,
      "bearer"
    );
  }
  getNearByDriversApi(query: any) {
    return this.networkservice.get(
      "api/driver/driverList?" + query,
      null,
      null,
      "bearer"
    );
  }
  assignDriver(body: any) {
    return this.networkservice.post(
      "api/booking/assign/driver",
      body,
      null,
      "bearer"
    );
  }
  postManagerApi(body: any) {
    return this.networkservice.post(
      "api/admins/manager?",
      body,
      null,
      "bearer"
    );
  }
  getManagerListApi(queryValue: any) {
    return this.networkservice.get(
      "api/admins/manager?" + queryValue,
      null,
      null,
      "bearer"
    );
  }
  putManagerApi(body: any) {
    return this.networkservice.put("api/admins/manager?", body, null, "bearer");
  }
  getAllManagerListApi(query: any) {
    return this.networkservice.get(
      "api/admins/manager?" + query,
      null,
      null,
      "bearer"
    );
  }

  deleteManager(managerId) {
    return this.networkservice.delete(
      "api/admins/manager/" + managerId,
      null,
      null,
      "bearer"
    );
  }
  getCouponListApi(query: any) {
    return this.networkservice.get("api/coupon?" + query, null, null, "bearer");
  }
  postCouponApi(body: any) {
    return this.networkservice.post("api/coupon?", body, null, "bearer");
  }
  deleteCoupon(couponId) {
    return this.networkservice.delete(
      "api/coupon/" + couponId,
      null,
      null,
      "bearer"
    );
  }
  putCouponApi(body: any) {
    return this.networkservice.put("api/coupon?", body, null, "bearer");
  }
  putDriverApi(body: any) {
    return this.networkservice.put("api/driver?", body, null, "bearer");
  }
  // getDriverPaymentApi(query:any) {
  //   return this.networkservice.get("api/driver/payment/weekly/summary?"+query,null, null,"bearer");
  // }

  getDriverPaymentApi(queryValue: any) {
    return this.networkservice.get(
      "api/driver/payment/weekly/summary?" + queryValue,
      null,
      null,
      "bearer"
    );
  }
  getDetailedPaymentApi(queryValue: any) {
    return this.networkservice.get(
      "api/driver/payment/weekly/details?" + queryValue,
      null,
      null,
      "bearer"
    );
  }
  postDriverPayApi(body: any) {
    return this.networkservice.post(
      "api/driver/payment/update?",
      body,
      null,
      "bearer"
    );
  }
  getNotificationListApi(query: string) {
    return this.networkservice.get(
      "/api/notification?" + query,
      null,
      null,
      "bearer"
    );
  }
  
  // markallasread api
  markAllAsRead() {
    return this.networkservice.post(
      "api/notification/mark-all-read",
      null,
      null,
      "bearer"
    );
  }
}